var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "", "mt-2": "" } },
        [
          _c("h1", [_vm._v("Account Info")]),
          _vm._v(" "),
          _c("v-img", {
            staticStyle: {
              "border-radius": "50%",
              height: "0px",
              width: "75px",
              margin: "30px"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("v-flex", { attrs: { xs12: "" } }, [
        _c(
          "form",
          [
            _c(
              "v-layout",
              { attrs: { column: "" } },
              [
                _c(
                  "v-flex",
                  [
                    _c(
                      "v-alert",
                      {
                        attrs: { type: "error", dismissible: "" },
                        model: {
                          value: _vm.alert,
                          callback: function($$v) {
                            _vm.alert = $$v
                          },
                          expression: "alert"
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.error) +
                            "\n            "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("h3", [_vm._v(" Account Verification")]),
                _vm._v(" "),
                _c("p", [_vm._v(" Account Verified")]),
                _vm._v(" "),
                _c("h3", [_vm._v(" Email Address")]),
                _vm._v(" "),
                _c("p", [_vm._v(" " + _vm._s(_vm.getEmail))]),
                _vm._v(" "),
                _c(
                  "v-flex",
                  [
                    _c("v-text-field", {
                      attrs: {
                        name: "password",
                        label: "Password",
                        id: "password",
                        autocomplete: "on",
                        "append-icon": "edit",
                        type: "text",
                        rules: _vm.passwordRules,
                        required: ""
                      },
                      on: {
                        "click:append": function($event) {
                          ;(_vm.wantToChange = !_vm.wantToChange),
                            (_vm.newPasswordSave = false)
                        }
                      },
                      model: {
                        value: _vm.password,
                        callback: function($$v) {
                          _vm.password = $$v
                        },
                        expression: "password"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  {
                    attrs: {
                      "align-center": "",
                      "justify-start": "",
                      row: "",
                      "fill-height": ""
                    }
                  },
                  [
                    !this.$store.state.check_Password
                      ? _c(
                          "div",
                          [
                            _c(
                              "v-alert",
                              { attrs: { value: true, type: "error" } },
                              [
                                _vm._v(
                                  "\n                The current password is incorrect.\n              "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _vm.wantToChange
                  ? _c(
                      "div",
                      [
                        _c(
                          "v-flex",
                          [
                            _c("v-text-field", {
                              attrs: {
                                name: "new password",
                                label: "New Password",
                                id: "new password",
                                rules: _vm.passwordRules,
                                required: ""
                              },
                              model: {
                                value: _vm.new_password,
                                callback: function($$v) {
                                  _vm.new_password = $$v
                                },
                                expression: "new_password"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          {
                            attrs: {
                              "align-center": "",
                              "justify-start": "",
                              row: "",
                              "fill-height": ""
                            }
                          },
                          [
                            this.$store.state.updatedPassword
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "v-alert",
                                      {
                                        attrs: { value: true, type: "success" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  New Password Saved\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          {
                            staticClass: "text-xs-center",
                            attrs: { "mt-4": "" }
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "primary",
                                  disabled: _vm.checkValid
                                },
                                on: { click: _vm.changePassword }
                              },
                              [_vm._v("Update")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", "mt-3": "" } },
        [
          _c("h1", [_vm._v("Profile Info")]),
          _vm._v(" "),
          _c("v-img", {
            staticStyle: {
              "border-radius": "50%",
              height: "0px",
              width: "75px",
              margin: "30px"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("v-flex", { attrs: { xs12: "" } }, [
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.saveProfile.apply(null, arguments)
              }
            }
          },
          [
            _c(
              "v-layout",
              { attrs: { column: "" } },
              [
                _c(
                  "v-flex",
                  [
                    _c(
                      "v-alert",
                      {
                        attrs: { type: "error", dismissible: "" },
                        model: {
                          value: _vm.alert,
                          callback: function($$v) {
                            _vm.alert = $$v
                          },
                          expression: "alert"
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.error) +
                            "\n            "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  [
                    _c("v-text-field", {
                      attrs: {
                        name: "name",
                        label: "Name",
                        id: "name",
                        type: "text",
                        "prepend-icon": "face"
                      },
                      model: {
                        value: _vm.profile.name,
                        callback: function($$v) {
                          _vm.$set(_vm.profile, "name", $$v)
                        },
                        expression: "profile.name"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  [
                    _c("v-textarea", {
                      attrs: {
                        name: "bio",
                        label: "Bio",
                        id: "bio",
                        type: "text",
                        "prepend-icon": "edit"
                      },
                      model: {
                        value: _vm.profile.bio,
                        callback: function($$v) {
                          _vm.$set(_vm.profile, "bio", $$v)
                        },
                        expression: "profile.bio"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  [
                    _c("v-text-field", {
                      attrs: {
                        name: "role",
                        label: "Role",
                        id: "role",
                        type: "text",
                        hint: "Administrator or User",
                        "prepend-icon": "accessibility_new"
                      },
                      model: {
                        value: _vm.profile.role,
                        callback: function($$v) {
                          _vm.$set(_vm.profile, "role", $$v)
                        },
                        expression: "profile.role"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  [
                    _c(
                      "v-menu",
                      {
                        ref: "menu",
                        attrs: {
                          "close-on-content-click": false,
                          "nudge-right": 40,
                          "return-value": _vm.profile.birthday,
                          lazy: "",
                          transition: "scale-transition",
                          "offset-y": "",
                          "full-width": "",
                          "min-width": "290px"
                        },
                        on: {
                          "update:returnValue": function($event) {
                            return _vm.$set(_vm.profile, "birthday", $event)
                          },
                          "update:return-value": function($event) {
                            return _vm.$set(_vm.profile, "birthday", $event)
                          }
                        },
                        model: {
                          value: _vm.menu,
                          callback: function($$v) {
                            _vm.menu = $$v
                          },
                          expression: "menu"
                        }
                      },
                      [
                        _c("v-text-field", {
                          attrs: {
                            slot: "activator",
                            label: "Birthday",
                            id: "birthday",
                            type: "text",
                            "prepend-icon": "event",
                            readonly: ""
                          },
                          slot: "activator",
                          model: {
                            value: _vm.profile.birthday,
                            callback: function($$v) {
                              _vm.$set(_vm.profile, "birthday", $$v)
                            },
                            expression: "profile.birthday"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "v-date-picker",
                          {
                            attrs: { "no-title": "", scrollable: "" },
                            model: {
                              value: _vm.profile.birthday,
                              callback: function($$v) {
                                _vm.$set(_vm.profile, "birthday", $$v)
                              },
                              expression: "profile.birthday"
                            }
                          },
                          [
                            _c("v-spacer"),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { flat: "", color: "primary" },
                                on: {
                                  click: function($event) {
                                    _vm.menu = false
                                  }
                                }
                              },
                              [_vm._v("Cancel")]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { flat: "", color: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.$refs.menu.save(
                                      _vm.profile.birthday
                                    )
                                  }
                                }
                              },
                              [_vm._v("OK")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-flex",
                  [
                    _c("v-text-field", {
                      attrs: {
                        name: "gender",
                        label: "Gender",
                        id: "gender",
                        type: "text",
                        "prepend-icon": "person_outline"
                      },
                      model: {
                        value: _vm.profile.gender,
                        callback: function($$v) {
                          _vm.$set(_vm.profile, "gender", $$v)
                        },
                        expression: "profile.gender"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  [
                    _c("v-text-field", {
                      attrs: {
                        name: "hometown",
                        label: "Hometown",
                        id: "hometown",
                        type: "text",
                        "prepend-icon": "home"
                      },
                      model: {
                        value: _vm.profile.hometown,
                        callback: function($$v) {
                          _vm.$set(_vm.profile, "hometown", $$v)
                        },
                        expression: "profile.hometown"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  [
                    _c("v-text-field", {
                      attrs: {
                        name: "location",
                        label: "Location",
                        id: "location",
                        type: "text",
                        "prepend-icon": "location_on"
                      },
                      model: {
                        value: _vm.profile.location,
                        callback: function($$v) {
                          _vm.$set(_vm.profile, "location", $$v)
                        },
                        expression: "profile.location"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.savedProfile
                  ? _c(
                      "v-flex",
                      { staticClass: "text-xs-center", attrs: { "mt-5": "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              outline: "",
                              color: "primary",
                              type: "submit"
                            }
                          },
                          [_vm._v("Save")]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { outline: "", color: "primary" },
                            on: { click: _vm.fbAuth }
                          },
                          [_vm._v("Pull From Facebook")]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-alert",
                  {
                    attrs: {
                      icon: "check_circle",
                      value: _vm.savedProfile,
                      transition: "scale-transition",
                      type: "success"
                    }
                  },
                  [
                    _vm._v(
                      "\n            Profile Successfully Saved\n          "
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ced23842", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ced23842","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Profile.vue
// module id = null
// module chunks = 